export default __webpack_public_path__ + "static/media/Say Gay Cutout small.a6a2eb04.png";